import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { boletos_online } from 'store/modules/my_account_store/actions';
import { MyAccountState } from 'store/modules/my_account_store/types';
import Loader from 'components/atoms/loader';
import TableIncomes from 'components/atoms/table_incomes';

const BoletosOnline = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(boletos_online());
  }, []);

  const { my_account, request } = useSelector<ApplicationState, MyAccountState>(
    (state) => state.session.my_account,
  );

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            {request?.incomes?.loading ? (
              <Loader />
            ) : (
              <>
                <div className="card-header">
                  <div className="row">
                    <div className="col-md-12">
                      <h3 className="card-title mb-0">Boletos Online</h3>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <TableIncomes data={my_account?.incomes} title="" />
                  <TableIncomes data={my_account?.future_sale_invoice_incomes} title="Renovação" />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoletosOnline;
